import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Service from '../Dashboard/services/Service';
import showToast from '../../../Shared/Utils/ToastNotification';
import './Medication.scss';

const SupplementInfo = () => {
  const [offerings, setOfferings] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchOffering();
  }, []);

  const fetchOffering = async () => {
    try {
      const response = await Service.getPatientOffering();
      const data = response?.data;
      const list = data?.offerings || [];
      if (!data?.has_offering || list.length === 0) {
        showToast('error', 'No supplement suggested for you');
        navigate('/dashboard');
      } else {
        setOfferings(list);
      }
    } catch (error) {
      showToast('error', 'Failed to load supplement information');
      navigate('/dashboard');
    } finally {
      setLoading(false);
    }
  };

  const handleProceed = () => {
    navigate('/medication');
  };

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  return (
    <div className="supplement-info-page">
      <div className="container">
        <div className="supplement-info-card">
          <h2>Recommended Supplement</h2>
          {offerings.length > 0 && (
            <>
              <div className="offering-details">
                {offerings.map((offering, index) => (
                  <h3 key={offering.offering_id + index}>
                    {offering.offering_title} - ${offering.price}
                  </h3>
                ))}
                <p className="offering-description">
                  This supplement has been specifically recommended for you by our medical team to support your reproductive health and improve your
                  fertility metrics.
                </p>

                <div className="details-section">
                  <h4>Whats Included</h4>
                  <ul className="benefits-list">
                    <li>Personalized supplement formulation tailored to your test results</li>
                    <li>High-quality ingredients backed by clinical research</li>
                    <li>Monthly supply with easy-to-follow dosage instructions</li>
                    <li>Ongoing support from our medical team</li>
                  </ul>
                </div>

                <div className="details-section">
                  <h4>How It Works</h4>
                  <ol className="steps-list">
                    <li>Complete the intake form to provide your medical history</li>
                    <li>Our medical team reviews your information</li>
                    <li>Once approved, your supplement will be shipped directly to you</li>
                    <li>Follow the recommended dosage for optimal results</li>
                  </ol>
                </div>

                <div className="details-section">
                  <h4>Expected Benefits</h4>
                  <ul className="benefits-list">
                    <li>Improved sperm count and motility</li>
                    <li>Enhanced reproductive health markers</li>
                    <li>Better overall fertility potential</li>
                    <li>Support for hormonal balance</li>
                  </ul>
                </div>

                <div className="info-note">
                  <strong>Note:</strong> Results may vary. Consistent use for 3-6 months is recommended for optimal benefits. This supplement is
                  designed to complement a healthy lifestyle.
                </div>
              </div>

              <div className="action-buttons">
                <button className="btn btn-secondary" onClick={() => navigate('/dashboard')}>
                  Back to Dashboard
                </button>
                <button className="btn btn-primary" onClick={handleProceed}>
                  Proceed to Intake Form
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupplementInfo;
